<template>
  <div class="app-container">
    <list ref="list" @type-change="typeChange" @change="onChange" @reload="reload">
      <template slot="toolbar-right" v-if="$permission.canWrite()" >
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
        <el-button type="danger" @click="delRows">删除</el-button>
      </template>
    </list>
    <div class="list-head" style="margin-top: 10px;">
      <span v-if="type==0">收款单明细</span>
      <span v-else>付款单明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details1" v-loading="loading1" show-summary>
      <el-table-column label="单据日期" min-width="120" align="center">
        <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="单据编号" min-width="150" align="center"  show-overflow-tooltip>
        <template slot-scope="{row}">{{row.DocNo}}</template>
      </el-table-column>
      <el-table-column label="往来单位" min-width="150" align="center" >
        <template slot-scope="{row}">{{row.TradeUnitName}}</template>
      </el-table-column>
      <el-table-column label="部门" min-width="100" align="center" >
          <template slot-scope="{row}">{{row.DpName}}</template>
      </el-table-column>
      <el-table-column label="经办人" min-width="100" align="center" >
        <template slot-scope="{row}">{{row.ClerkName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" width="120" align="center" v-if="canPrice">
        <template slot-scope="{row}">{{row.Amount.toLocaleString()}}</template>
      </el-table-column>
      <el-table-column prop="NoSettleAmount" label="应核销金额" width="120" align="center" v-if="canPrice"/>
      <el-table-column prop="WriteoffAmount" label="本次销金额" width="120" align="center"  v-if="canPrice"/>
      <el-table-column prop="TotalAmount" label="累计销金额" width="120" align="center" v-if="canPrice" />
    </el-table>
    <div class="list-head" style="margin-top: 10px;">
      <span>核销明细</span>
    </div>
    <el-table class="tb-c-head" border :data="Details2" v-loading="loading2" show-summary>
      <el-table-column label="单据类型" min-width="80" align="center" >
        <template slot-scope="{row}">{{row.SourceTypeName}}</template>
      </el-table-column>
      <el-table-column label="单据日期" min-width="100" align="center" >
        <template slot-scope="{row}">{{$commonJs.toDateString(row.DocDate)}}</template>
      </el-table-column>
      <el-table-column label="单据编号" min-width="150" align="center" show-overflow-tooltip>
        <template slot-scope="{row}">{{row.DocNo}}</template>
      </el-table-column>
      <el-table-column label="往来单位" min-width="150" align="center" >
        <template slot-scope="{row}">{{row.TradeUnitName}}</template>
      </el-table-column>
      <el-table-column label="部门" min-width="90" align="center" >
          <template slot-scope="{row}">{{row.DpName}}</template>
      </el-table-column>
      <el-table-column label="经办人" min-width="90" align="center" >
        <template slot-scope="{row}">{{row.ClerkName}}</template>
      </el-table-column>
      <el-table-column prop="Amount" label="金额" width="120" align="center" v-if="canPrice">
        <template slot-scope="{row}">{{row.Amount.toLocaleString()}}</template>
      </el-table-column>
      <el-table-column prop="NoSettleAmount" label="应核销金额" width="120" align="center" v-if="canPrice" />
      <el-table-column prop="WriteoffAmount" label="本次销金额" width="120"   align="center"  v-if="canPrice"/>
    </el-table>
    <edit-dialog ref="editDialog" @close-saved="reload" />
    <check-dialog ref="checkDialog" @confirm="confirm" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from "@/components/finance/dealings/writeoff/list";
import editDialog from "@/components/finance/dealings/writeoff/editDialog";
import checkDialog from "@/components/finance/dealings/writeoff/checkDialog";

export default {
  name: "writeoff",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    checkDialog,
  },
  data() {
    return {

      api: require("@/api/rp/rpWoDoc").default,
      rp_api: require("@/api/rp/rpWoDocRp").default,
      wo_api: require("@/api/rp/rpWoDocWo").default,
      Details1: [], //收/付款单明细
      Details2: [], //核销明细
      loading1: false,
      loading2: false,
      type: 0,
      isMB: this.$store.state.isMB,
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/finance/dealings/writeoff");
    },
  },
  methods: {
    reload() {
      this.$refs.list.reload();
      this.Details1 = [];
      this.Details2 = [];
    },
    onChange(row) {
      console.log("选中行", JSON.parse(JSON.stringify(row)));
      this.Details1 = [];
      this.Details2 = [];
      this.loading1 = true;
      //收/付款单明细
      this.rp_api.list({ WoDocID: row.WoDocId }).then((res) => {
        this.loading1 = false;
        if (res.Code == 0) this.Details1 = res.Data;
      });
      this.loading2 = true;
      //核销明细
      this.wo_api.list({ WoDocID: row.WoDocId }).then((res) => {
        this.loading2 = false;
        if (res.Code == 0) this.Details2 = res.Data;
      });
    },
    typeChange(type) {
      this.type = type;
      this.Details1 = [];
      this.Details2 = [];
    },
    create() {
      this.$refs.checkDialog.open();
    },
    confirm(data) {
      // console.log("筛选", data);
      this.$refs.editDialog.openCreate(data);
    },
    delRows() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.$confirm("确认删除所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let ids = rows.map((item) => {
            return item.WoDocId;
          });
          this.$refs.list.delRange(ids);
        })
        .catch(() => {});
    },
  },
};
</script>